var map = {
	"./ami_pin_white.svg": "77ef",
	"./bike_pin_white.svg": "c73c",
	"./car_pin_white.svg": "d700",
	"./horse_pin_white.svg": "ffeb",
	"./kickscooter_pin_white.svg": "a18a",
	"./micro_pin_white.svg": "9880",
	"./minibus_pin_white.svg": "12e2",
	"./platform_pin_white.svg": "42ec",
	"./scooter_pin_white.svg": "3099",
	"./van_pin_white.svg": "dab7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8713";